
import React, { useState, useId } from "react";
import "./accordion.scss";

export const Accordion = ({ title, children, className, open, ...props }) => {
  const [expanded, setExpanded] = useState(open || false);
  const id = useId();

  return (
    <div className={`dd-accordion ${className || ""}`} {...props}>
      <button
        className="dd-accordion-trigger"
        onClick={() => setExpanded(!expanded)}
        aria-expanded={expanded}
        aria-controls={id}
      >
        <span>{title}</span>
      </button>

      <div
        id={id}
        className="dd-accordion-container"
        role="region"
        aria-hidden={!expanded}
      >
        <div className="dd-accordion-content-wrapper">
          <div className="dd-accordion-content">{children}</div>
        </div>
      </div>
    </div>
  );
};
